import { render } from "./BluePrint.vue?vue&type=template&id=cb31c0f8&scoped=true"
const script = {}

import "./BluePrint.vue?vue&type=style&index=0&id=cb31c0f8&lang=scss&scoped=true"

import exportComponent from "/data/.jenkins/workspace/Shita-erp-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb31c0f8"]])

export default __exports__